<template>
  <div class="nav-menu-buttons" :key="$i18n.locale">
    <!-- <v-btn :href="link.saas.contact" icon dark>
                <v-icon>mdi-email-outline</v-icon>
              </v-btn> -->

    <div v-if="!isAuthenticated" class="text-no-wrap">
      <v-btn
        :icon="$vuetify.breakpoint.xs"
        rounded
        name="login-button"
        :to="{ name: 'login' }"
        class="login text-btn"
        text
      >
        <v-icon>mdi-login</v-icon>
        <span class="ml-2 d-none d-sm-inline" v-t="'Sign in'" />
      </v-btn>
      <v-btn
        class="register button"
        :to="{ name: 'register' }"
        color="secondary"
        v-if="$vuetify.breakpoint.smAndUp"
      >
        <span v-t="'Register'" />
      </v-btn>
    </div>
    <div v-else>
      <v-btn
        key="xs"
        v-if="$route.name !== 'home' && $vuetify.breakpoint.xs"
        :to="{ name: 'home' }"
        color="secondary"
        class="my-account mr-5"
        small
        fab
      >
        <v-icon>mdi-account</v-icon>
      </v-btn>
      <v-btn
        class="button my-account"
        key="smAndUp"
        v-else-if="$route.name !== 'home'"
        :to="{ name: 'home' }"
        color="secondary"
      >
        <small><span v-t="'My Account'" /></small>
      </v-btn>
      <logout-btn class="text-btn" text dark v-if="$vuetify.breakpoint.smAndUp"></logout-btn>
    </div>
  </div>
</template>

<script>
import link from "@/landing/static/text/link";

export default {
  data() {
    return {
      link,
    };
  },
  computed: {
    isAuthenticated() {
      return this.$store.state.auth;
    },
  },
  methods: {},
};
</script>

<style scoped lang="scss">
@import "./header-style";
</style>
